import React, { useState } from "react";
import { useProductGroupCategory } from "../../../../api/product-group-category/use-product-group-category";
import Button from "../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";

const checkByOptions = [
  {
    id: "ref",
    name: "REF(상품코드)",
  },
  {
    id: "name",
    name: "상품 그룹명/상품명",
  },
];

function Filter(props) {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    searchBy,
    onChangeSearchBy,
  } = props;
  const { data: categories } = useProductGroupCategory();
  const categoriesData = [
    {
      id: "",
      name: "전체",
    },
    ...categories,
  ];
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();

  const onResetFilterAll = () => {
    onResetFilter();
    setDiscountStartDate(null);
    setDiscountEndDate(null);
  };

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      from: value?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      to: value?.unix(),
    });
  };
  const onChangeDateTo = (increment) => {
    if (discountEndDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const subtracted = discountEndDate.subtract(increment, "day");
        setDiscountStartDate(subtracted);
        onFilter({
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 30) {
        const subtracted = discountEndDate.subtract(1, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 90) {
        const subtracted = discountEndDate.subtract(3, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
    }
  };

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="mb-8 rounded-[4px]"
    >
      <div className="flex items-center px-5 pt-5 pb-[10px]">
        <div className="flex items-center">
          <span className="w-24">검색어</span>
          <div className="flex gap-4">
            <Dropdown
              width="w-36"
              positionDropdown={"top-10"}
              placeholder="REF(상품코드)"
              textColor="text-black"
              options={checkByOptions}
              onClickItem={onChangeSearchBy}
            />
            <input
              type="text"
              className="h-8 w-[26rem] border border-button-grey rounded-[4px] p-2"
              placeholder="필터 선택 후, 검색"
              onChange={(e) => onFilter({ [searchBy]: e.target.value })}
            />
            <button
              className={`bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey h-8 w-[6rem] rounded-[4px]`}
            >
              QR 스캔
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center px-5 pb-5 mt-1">
        <div className="flex items-center gap-[5rem] w-full">
          <div className="flex items-center">
            <span className="w-24">카테고리</span>
            <Dropdown
              width="w-36"
              positionDropdown={"top-10"}
              placeholder="카테고리 선택"
              textColor="text-black"
              options={categoriesData}
              onClickItem={(id) => onFilter({ categoryId: id })}
            />
          </div>

          <div className="flex items-center gap-[8px] w-1/2">
            <span className="w-12">기간</span>
            <InputDate
              value={discountStartDate}
              onChange={onChangeDiscountStartDate}
              defaultValue={discountStartDate}
            />
            {" - "}
            <InputDate
              value={discountEndDate}
              onChange={onChangeDiscountEndDate}
              defaultValue={discountEndDate}
            />
            <div
              className={`border h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
            >
              <div
                onClick={() => onChangeDateTo(1)}
                className={`${
                  selectedDateOption === 1
                    ? "bg-primary-blue rounded-l-[4px] text-white"
                    : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
              >
                오늘
              </div>
              <div
                onClick={() => onChangeDateTo(7)}
                className={`${
                  selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                7일
              </div>
              <div
                onClick={() => onChangeDateTo(30)}
                className={`${
                  selectedDateOption === 30 ? "bg-primary-blue text-white" : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                1개월
              </div>
              <div
                onClick={() => onChangeDateTo(90)}
                className={`${
                  selectedDateOption === 90
                    ? "bg-primary-blue rounded-r-[4px] text-white"
                    : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                3개월
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4 w-full border-t border-disable-grey " />
      <div className="pb-4 flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          className="border p-1 border-secondary-grey"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilterAll}
          className="border p-1 border-secondary-grey"
          text="필터 초기화"
        />
      </div>
    </div>
  );
}

export default Filter;
